// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"821":"cd096798","884":"55927fc6"}[chunkId] + ".chunk.js";
};